export default __webpack_public_path__ + "static/media/boxes-icon-white.6a18ba98.svg";